import * as BABYLON from "babylonjs";
import * as Logger from "js-logger";
import { CoordUtils } from "../core/coordUtils";
import { Intersector } from "../core/intersector";
import { Signal } from "../core/signal";
import { CountryMesh } from "../display/countryMesh";
import { CountryOutlineMesh } from "../display/countryOutlineMesh";
import { EarthEngine } from "../earthEngine";
import { Country } from "../model/country";
import { Land } from "../model/land";
import { CountryService } from "../services/countryService";

export interface EarthTappedEvent {
    country: Country | null;
    event: BABYLON.PointerInfo;
}
export interface SkyTappedEvent {
    event: BABYLON.PointerInfo;
}
export interface ScreenTouchedEvent {
    event: BABYLON.PointerInfo;
}

export class InteractionManager {
    private _highlightedCountryMesh: CountryMesh | null = null;
    private _highlightedCountryOutlineMesh: CountryOutlineMesh | null = null;
    earthTapped = new Signal<EarthTappedEvent> ();
    skyTapped = new Signal<SkyTappedEvent> ();
    screenTouched = new Signal<ScreenTouchedEvent> ();

    highlightCountry(country: Country | null) {
        if (this._highlightedCountryMesh) { this._highlightedCountryMesh.dispose(); }
        if (this._highlightedCountryOutlineMesh) { this._highlightedCountryOutlineMesh.dispose(); }
        this._highlightedCountryMesh = country ? new CountryMesh(EarthEngine.instance.scene, country) : null;
        this._highlightedCountryOutlineMesh = country ? new CountryOutlineMesh(EarthEngine.instance.scene, country) : null;
    }

    focusCameraOnLand(land: Land) {
        EarthEngine.instance.camera.focusOnPosition(land.focusPosition, land.cameraAltitude);
    }

    onDown(tapEvent: BABYLON.PointerInfo) {
        this.screenTouched.emit({event: tapEvent});
    }

    onTap(tapEvent: BABYLON.PointerInfo) {
        let tapX = tapEvent.event.x;
        let tapY = tapEvent.event.y;
        let pickingRay = EarthEngine.instance.scene.createPickingRay(tapX, tapY, BABYLON.Matrix.Identity(), EarthEngine.instance.camera);
        let earthIntersection = Intersector.intersectSphereAndRay(BABYLON.Vector3.Zero(), 1.0, pickingRay);

        if (earthIntersection == null) {
            Logger.info("User tapped the sky");
            this.skyTapped.emit({event: tapEvent});
        } else {
            let position = CoordUtils.babylonToGeo(earthIntersection);
            let country = CountryService.instance.getCountryAtPosition(position);
            Logger.info(`User tapped the Earth on country: ${country ? country.isoCode : null}`);
            this.earthTapped.emit({country, event: tapEvent});
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/earth/ui/interactionManager.ts